module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-300.7af7d3e6.woff";